import { IrregularMapping } from '@javascript/types/IrregularMapping.js';
import { titleize } from './utils';

const irregularDecode: IrregularMapping = {
  '595c': '595C',
  '4c': '4C',
  '4c-spider': '4C Spider',
  a110s: 'A110 S',
  tt: 'TT',
  'e-tron': 'e-tron',
  'rs-e-tron-gt': 'RS e-tron GT',
  i3: 'i3',
  i5: 'i5',
  i7: 'i7',
  i8: 'i8',
  ix: 'iX',
  i4: 'i4',
  ix2: 'iX2',
  ix3: 'iX3',
  ix1: 'iX1',
  xm: 'XM',
  'atto-3': 'ATTO 3',
  '300c': '300C',
  'c-crosser': 'C-Crosser',
  ds3: 'DS3',
  ds4: 'DS4',
  ds5: 'DS5',
  ds7: 'DS7',
  'ds-3': 'DS 3',
  'ds-4': 'DS 4',
  'ds-5': 'DS 5',
  'ds-7': 'DS 7',
  'ds-9': 'DS 9',
  '500c': '500C',
  '500l': '500L',
  '500l-mpw': '500L MPW',
  '500x': '500X',
  'b-max': 'B-MAX',
  'c-max': 'C-MAX',
  'focus-rs': 'Focus RS',
  'grand-b-max': 'Grand B-MAX',
  'grand-c-max': 'Grand C-MAX',
  'grand-s-max': 'Grand S-MAX',
  'mustang-mach-e': 'Mustang Mach-E',
  's-max': 'S-MAX',
  's-max-vignale': 'S-MAX Vignale',
  gv60: 'GV60',
  gv70: 'GV70',
  gv80: 'GV80',
  'ora-03': 'ORA 03',
  'cr-v': 'CR-V',
  'cr-z': 'CR-Z',
  'e-ny1': 'e Ny1',
  'fr-v': 'FR-V',
  'hr-v': 'HR-V',
  'zr-v': 'ZR-V',
  bayon: 'BAYON',
  genesis: 'GENESIS',
  inster: 'INSTER',
  ioniq: 'IONIQ',
  'ioniq-5': 'IONIQ 5',
  'ioniq-5-n': 'IONIQ 5 N',
  'ioniq-6': 'IONIQ 6',
  'ioniq-9': 'IONIQ 9',
  i10: 'i10',
  i20: 'i20',
  i30: 'i30',
  i40: 'i40',
  ix20: 'ix20',
  ix35: 'ix35',
  kona: 'KONA',
  'santa-fe': 'SANTA FE',
  tucson: 'TUCSON',
  'd-max': 'D-Max',
  'f-pace': 'F-Pace',
  'i-pace': 'I-Pace',
  's-type': 'S-Type',
  'e-pace': 'E-Pace',
  'f-type': 'F-Type',
  'x-type': 'X-Type',
  xe: 'XE',
  xf: 'XF',
  xj: 'XJ',
  'e-niro': 'e-Niro',
  ev3: 'EV3',
  ev4: 'EV4',
  ev6: 'EV6',
  ev9: 'EV9',
  proceed: 'ProCeed',
  xceed: 'XCeed',
  pv5: 'PV5',
  ev5: 'EV5',
  ct: 'CT',
  is: 'IS',
  nx: 'NX',
  rc: 'RC',
  rx: 'RX',
  'cx-3': 'CX-3',
  'cx-4': 'CX-4',
  'cx-5': 'CX-5',
  'cx-6': 'CX-6',
  'cx-7': 'CX-7',
  'cx-8': 'CX-8',
  'cx-9': 'CX-9',
  'cx-30': 'CX-30',
  'cx-60': 'CX-60',
  'cx-80': 'CX-80',
  'mx-5': 'MX-5',
  'mx-30': 'MX-30',
  'amg-gt': 'AMG GT',
  cla: 'CLA',
  clc: 'CLC',
  cle: 'CLE',
  cls: 'CLS',
  eqa: 'EQA',
  eqb: 'EQB',
  eqc: 'EQC',
  eqe: 'EQE',
  eqs: 'EQS',
  eqv: 'EQV',
  gla: 'GLA',
  glb: 'GLB',
  glc: 'GLC',
  gle: 'GLE',
  gls: 'GLS',
  slc: 'SLC',
  slk: 'SLK',
  sprinter: 'Sprinter',
  asx: 'ASX',
  '350z': '350Z',
  '370z': '370Z',
  'x-trail': 'X-Trail',
  'gt-r': 'GT-R',
  'e-nv200': 'e-NV200',
  rcz: 'RCZ',
  kadjar: 'KADJAR',
  zoe: 'ZOE',
  'megane-e-tech-electric': 'Megane E-TECH Electric',
  'scenic-e-tech': 'Scenic E-Tech',
  '9-3': '9-3',
  'leon-x-perience': 'Leon X-Perience',
  'enyaq-iv': 'Enyaq iV',
  fortwo: 'fortwo',
  'fortwo-coupe': 'fortwo coupé',
  'fortwo-cabrio': 'fortwo cabrio',
  forfour: 'forfour',
  'forfour-hatchback': 'forfour hatchback',
  'eq-fortwo': 'EQ fortwo',
  'eq-fortwo-coupe': 'EQ fortwo coupé',
  'eq-fortwo-cabrio': 'EQ fortwo cabrio',
  'eq-forfour': 'EQ forfour',
  'eq-forfour-hatchback': 'EQ forfour hatchback',
  sx4: 'SX4',
  'sx4-s-cross': 'SX4 S-Cross',
  's-cross': 'S-Cross',
  'c-hr': 'C-HR',
  'c-hr-hybrid': 'C-HR Hybrid',
  'gr-yaris': 'GR Yaris',
  gt86: 'GT86',
  iq: 'iQ',
  'new-prius-plug-in': 'New Prius Plug-In',
  'prius-plug-in': 'Prius Plug-In',
  'prius-': 'Prius+',
  proace: 'PROACE',
  'proace-verso': 'PROACE VERSO',
  rav4: 'RAV4',
  'rav4-hybrid': 'RAV4 Hybrid',
  'verso-s': 'Verso-S',
  'astra-gtc': 'Astra GTC',
  gtc: 'GTC',
  cc: 'CC',
  'golf-sv': 'Golf SV',
  'passat-cc': 'Passat CC',
  't-cross': 'T-Cross',
  't-roc': 'T-Roc',
  up: 'up',
  'id.3': 'ID.3',
  'id.4': 'ID.4',
  'id.5': 'ID.5',
  'id.7': 'ID.7',
  ec40: 'EC40',
  ex30: 'EX30',
  ex40: 'EX40',
  ex90: 'EX90',
  xc40: 'XC40',
  xc60: 'XC60',
  xc70: 'XC70',
  xc90: 'XC90',
  es90: 'ES90',
  gs: 'GS',
  hs: 'HS',
  mg3: 'MG3',
  mg4: 'MG4',
  mg5: 'MG5',
  mg6: 'MG6',
  zs: 'ZS',
  mgs5: 'MGS5 EV',
  'mgs6-ev': 'MGS6 EV',
  im5: 'IM5',
  im6: 'IM6',
  'megane-r.s.': 'Megane R.S.',
  'megane-r-s': 'Megane R.S.',
  'Seal U': 'Seal U DM-i',
};

const irregularDisplay: IrregularMapping = {
  up: 'up!',
  'a-class': 'A-Class',
  'b-class': 'B-Class',
  'c-class': 'C-Class',
  'cla-class': 'CLA',
  'e-class': 'E-Class',
  enyaq: 'Enyaq iV',
  'gl-class': 'GL',
  'gla-class': 'GLA',
  'g-class': 'G-Class',
  'm-class': 'M-Class',
  'ora-funky-cat': 'Funky Cat',
  'sl-class': 'SL',
  'v-class': 'V-Class',
  'x-class': 'X-Class',
  's-class': 'S-Class',
  'honda-e': 'e',
  'e-ny1': 'e:Ny1',
  'id.buzz': 'ID. Buzz',
  'id.-buzz': 'ID. Buzz',
  'id-3': 'ID.3',
  'id-4': 'ID.4',
  'id-5': 'ID.5',
  'id-7': 'ID.7',
  'hashtag-1': '#1',
  'hashtag-3': '#3',
  'scenic-e-tech': 'Scenic E-Tech',
  'glc-coupe': 'GLC Coupé',
  'gle-coupe': 'GLE Coupé',
  'qashqai-2': 'Qashqai+2',
};

const irregularUrlParam: IrregularMapping = {
  'id-3': 'id.3',
  'id-4': 'id.4',
  'id-5': 'id.5',
  'id-7': 'id.7',
  'megane-r-s': 'megane r.s.',
};

const modelsEncoding: IrregularMapping = Object.fromEntries(
  [
    ...Object.entries(irregularDisplay),
    ...Object.entries(irregularDecode),
    ...Object.entries(irregularUrlParam),
  ].map(([key, value]) => [value, key])
);

function encodeModel(model: string) {
  return modelsEncoding[model] || model.toLowerCase().replace(/ /g, '-');
}

function decodeModel(model: string) {
  if (!model) {
    return null;
  }
  const encoded = encodeModel(model);
  return irregularDecode[encoded] || titleize(encoded, '-');
}

function displayNameModel(model: string) {
  if (!model) {
    return null;
  }
  const encoded = encodeModel(model);
  return irregularDisplay[encoded] || decodeModel(model);
}

function urlModel(model: string) {
  const encoded = encodeModel(model);
  return irregularUrlParam[encoded] || encoded;
}

//export functions for use in other modules
export { encodeModel, decodeModel, displayNameModel, urlModel };
